var ubian = ubian || {};
ubian.mapster = {
  unselectAll: function () {
    $(".js-bid-scheme-panel area").each(function () {
      $(this).mapster("set", false);
    });
  },
  selectZones: function () {
    $(ubian.zones.selectedZones).each(function (idx, val) {
      $(".js-bid-scheme-panel area[data-zone=" + val + "]").mapster(
        "set",
        true
      );
    });
  },
  updateSelectedZones: function (zonesString) {
    ubian.zones.selectedZones = [];
    if (zonesString) {
      var zones = zonesString.split(",");
      ubian.zones.addZones(zones, true);
    }
  },
  init: function () {
    if ($(".js-zone-map").length == 0) {
      return;
    }
    $(".js-show-ids-map").click(function () {
      $(".js-bid-scheme-panel").toggleClass("open");
      ubian.mapster.unselectAll();
      ubian.mapster.selectZones();
      return false;
    });
    $(".js-bid-scheme-panel").click(function (evt) {
      if ($(evt.target).hasClass("js-bid-scheme-panel")) {
        $(this).removeClass("open");
      }
    });
    var $BIDmap;
    var default_options = {
      fade: true,
      render_highlight: {
        stroke: false,
        fillOpacity: 0.3,
        fillColor: "00ff00",
      },
      render_select: {
        stroke: false,
        altImage: __ubian_timeticket_zonemap_alt,
        fillOpacity: 1,
      },
      mapKey: "data-zone",
      areas: [{ key: "BID", isMask: true }],
      clickNavigate: true,
      showToolTip: true,
    };
    $BIDmap = $(".map");
    $(".js-confirm-map-zones").click(function () {
      ubian.mapster.updateSelectedZones($BIDmap.mapster("get"));
      $(".js-bid-scheme-panel").removeClass("open");
    });
    $BIDmap.mapster(default_options);
    window.bidmap = $BIDmap;
  },
};
$(document).ready(function () {
  ubian.mapster.init();
});
